import {pushDataLayerEcommerceObject} from '~/CreateFabricInvitation/utils/dataTracking';
import {GREETING_CARD_CHECKED_OUT} from '~/common/fabric/reducers/review/constants';
import {selectEcommerceObject} from '~/common/fabric/reducers/review/selectors';

export const dataLayerMiddleware = (store) => (next) => (action) => {
  let ecommerce = null;
  try {
    const s = store.getState();
    // TODO: get ecommerce data for invitation checkout
    ecommerce = selectEcommerceObject(s);
    switch (action.type) {
      case GREETING_CARD_CHECKED_OUT:
        next(action);

        pushDataLayerEcommerceObject(ecommerce);
        break;

      default:
        next(action);
        break;
    }
  } catch (e) {
    evite.error('CreateFabricInvitation::dataLayerMiddleware failed', e);
  }
};
